import React from "react";

/* =======================
   Styles
======================= */
import styles from "./ToggleSwitch.module.scss";

const ToggleSwitch = ({ isOn = false, onToggle, disabled = false }) => {
  return (
    <label className={styles["admin-toggle-switch"]}>
      <input
        type="checkbox"
        className={styles["admin-toggle-switch__input"]}
        checked={isOn}
        onChange={onToggle}
        disabled={disabled}
        role="switch"
        aria-checked={isOn}
      />
      <div className={styles["admin-toggle-switch__slider"]}>
        <div className={styles["admin-toggle-switch__thumb"]} />
      </div>
    </label>
  );
};

export default ToggleSwitch;
